export const environment = {
    production: true,
    state: "production",
    baseUrl: "https://malirang.com",
    nhn: {
        objectStorageContainer: "assets",
    },
    lpinspection: {
        url: "https://inspection.malirang.com",
    },
};
